module.exports = __webpack_public_path__ + "img/user.c05bc71.png";